import { Inject, Injectable } from '@angular/core';
import { CompanyResource } from '@app/shared/modules/resources/company.resource';
import { CompanyService } from '@app/shared/services/company.service';
import { environment } from '@environments/environment';
import { IFBWindow } from '@app/models/window-namespace';
import { UserManager } from '@app/shared/services/user-manager.service';
import { featureFlags } from '@utils/feature-flags';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MatomoService {
  enabled = false;

  constructor(
    @Inject('Window') private window: IFBWindow,
    private companyResource: CompanyResource,
    private companyService: CompanyService,
    private userManager: UserManager
  ) {}

  init() {
    // Features are available at runtime
    if (!featureFlags.isOn('CompanyFeature.webAnalytics')) {
      return;
    }

    this.enabled = true;

    this.window._paq = this.window._paq || [];
    this.window._paq.push(['disableCookies']);
    this.window._paq.push(['enableLinkTracking']);

    const base = `//${environment.PIWIK_BASE}/`;
    this.window._paq.push(['setTrackerUrl', `${base}matomo.php`]);
    this.window._paq.push(['setSiteId', environment.PIWIK_SITE_ID]);

    this.loadMatomoLib(`${base}matomo.js`);

    this.setCustomDimensions();
  }

  push(...args: any[]): void {
    if (this.enabled) {
      this.window._paq.push(args);
    }
  }

  // Set custom dimensions for visit
  setCustomDimensions() {
    if (!this.userManager.isLoggedIn || !this.enabled) {
      return;
    }

    this.push('setCustomDimension', 1, this.userManager.roleInCompany(this.userManager.data)); // User role
    this.push('setCustomDimension', 2, this.userManager.data.locale); // User language

    this.companyResource
      .getCompany(this.companyService.data.id)
      .pipe(first())
      .subscribe(company => {
        this.push('setCustomDimension', 3, company.companySize); // Company size
        this.push('setCustomDimension', 4, company.country); // Company location
        this.push('setCustomDimension', 5, company.domainName); // Company domain
      });
  }

  loadMatomoLib(srcUrl) {
    const script = document.createElement('script');
    script.src = srcUrl;
    document.head.appendChild(script);
  }
}
